import React, { memo, useEffect } from "react"
import AOS from "aos"
import "aos/dist/aos.css"
import * as style from "./counter.module.css"

const Counter = ({ homeCounterList, homeCounterShowSection }) => {
  useEffect(() => {
    AOS.init({ once: true })
  }, [])

  useEffect(() => {
    if (homeCounterShowSection === "yes") {
      const animateValue = (obj, start, end, duration) => {
        let startTimestamp = null
        const step = timestamp => {
          if (!startTimestamp) startTimestamp = timestamp
          const progress = Math.min((timestamp - startTimestamp) / duration, 1)
          obj.textContent = Math.floor(progress * (end - start) + start)
          if (progress < 1) {
            window.requestAnimationFrame(step)
          }
        }
        window.requestAnimationFrame(step)
      }

      // Select all counter elements and apply the animation
      const counters = document.querySelectorAll(".counter-value")
      counters.forEach(counter => {
        const endValue = parseInt(counter.dataset.end, 10) || 0
        animateValue(counter, 0, endValue, 2000) // Adjust duration as needed
      })
    }
  }, [homeCounterShowSection])

  return (
    <>
      {homeCounterShowSection === "yes" && (
        <section className={style.counter}>
          <div className="row">
            <div className={style.counter_wrapper}>
              <ul className={style.counter_listing}>
                {homeCounterList?.map((item, index) => (
                  <li key={index}>
                    <strong
                      id={index}
                      className="counter-value"
                      data-end={item?.homeCounterListTitle}
                    >
                      {item?.homeCounterListTitle}
                    </strong>
                    <span className={style.plus_text}>+</span>
                    <p>{item?.homeCounterListSubTitle}</p>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </section>
      )}
    </>
  )
}

export default memo(Counter)
